import type { HtmlAttributes } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Icon } from '#~/control/preset/components/icon/index.js';
import { Contingency } from '#~/room/components/common/index.js';
import type { ContingencyProps } from '#~/room/components/common/index.js';

/** @internal */
const Inner = ({ className, ...props }: Omit<ContingencyProps, 'icon'>): ReactElement => (
  <Contingency
    className={twMerge('mx-auto h-full max-w-[300px] justify-center', className)}
    icon={Icon}
    {...props}
  />
);

/** `<Empty>` component. */
export const Empty = (props: HtmlAttributes): ReactElement => (
  <Inner
    {...props}
    message='You must first add a video source in order to define position presets.'
  />
);
